module.exports = __webpack_public_path__ + "static/media/chat_notification.378f1992.wav";